import { render } from "./mvr.vue?vue&type=template&id=2c01ba39"
import script from "./mvr.vue?vue&type=script&lang=js"
export * from "./mvr.vue?vue&type=script&lang=js"

import "./mvr.vue?vue&type=style&index=0&id=2c01ba39&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__